import api from './api'

const overtimeService = {
  // 取得加班申請列表
  getRequests: (params) => api.get('/overtime/requests', { params }),

  // 取得單筆加班申請
  getRequest: (id) => api.get(`/overtime/requests/${id}`),

  // 建立加班申請
  createRequest: (data) => api.post('/overtime/create', data),

  // 核准加班申請
  approve: (id, data) => api.post(`/overtime/requests/${id}/approve`, data),

  // 拒絕加班申請
  reject: (id, data) => api.post(`/overtime/requests/${id}/reject`, data),

  // 取消加班申請
  cancel: (id) => api.post(`/overtime/requests/${id}/cancel`),

  // 取得待審核列表
  getPending: (params) => api.get('/overtime/pending', { params }),

  // 加班統計
  getStatistics: (params) => api.get('/overtime/statistics', { params }),

  // 批次核准
  bulkApprove: (request_ids, comment = '') =>
    api.post('/overtime/requests/bulk-approve', { request_ids, comment }),

  // 批次駁回
  bulkReject: (request_ids, comment = '') =>
    api.post('/overtime/requests/bulk-reject', { request_ids, comment }),
}

export default overtimeService
